import BaseView from 'BaseView';

export default BaseView.extend({
	el: '#js_messageView',

	template: 'activity/inc/message',

	events: {
		'click .js_messageSearchLastYear': 'clickSearchLastYear'
	},

	initialize() {
		this.listenTo(this.model, 'change:message', this.render);
	},

	clickSearchLastYear() {
		this.model.filterModel.doLastYearSearch();
	}
});



// WEBPACK FOOTER //
// ./view/activity/messageView.es6